/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Rate_Billing_OnceInputs */

const en_admin_resource_form_rate_billing_once = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`once`)
};

const de_admin_resource_form_rate_billing_once = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`einmalig`)
};

const es_admin_resource_form_rate_billing_once = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`una vez`)
};

const fr_admin_resource_form_rate_billing_once = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`une fois`)
};

const nl_admin_resource_form_rate_billing_once = /** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eenmalig`)
};

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */
const it_admin_resource_form_rate_billing_once = en_admin_resource_form_rate_billing_once;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */
const pt_br2_admin_resource_form_rate_billing_once = en_admin_resource_form_rate_billing_once;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */
const pl_admin_resource_form_rate_billing_once = en_admin_resource_form_rate_billing_once;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */
const hu_admin_resource_form_rate_billing_once = en_admin_resource_form_rate_billing_once;

/** @type {(inputs: Admin_Resource_Form_Rate_Billing_OnceInputs) => LocalizedString} */
const ro_admin_resource_form_rate_billing_once = en_admin_resource_form_rate_billing_once;

/**
* | output |
* | --- |
* | "once" |
*
* @param {Admin_Resource_Form_Rate_Billing_OnceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_rate_billing_once = /** @type {((inputs?: Admin_Resource_Form_Rate_Billing_OnceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Rate_Billing_OnceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_rate_billing_once(inputs)
	if (locale === "de") return de_admin_resource_form_rate_billing_once(inputs)
	if (locale === "es") return es_admin_resource_form_rate_billing_once(inputs)
	if (locale === "fr") return fr_admin_resource_form_rate_billing_once(inputs)
	if (locale === "nl") return nl_admin_resource_form_rate_billing_once(inputs)
	if (locale === "it") return it_admin_resource_form_rate_billing_once(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_rate_billing_once(inputs)
	if (locale === "pl") return pl_admin_resource_form_rate_billing_once(inputs)
	if (locale === "hu") return hu_admin_resource_form_rate_billing_once(inputs)
	return ro_admin_resource_form_rate_billing_once(inputs)
});
export { admin_resource_form_rate_billing_once as "admin.resource_form.rate_billing_once" }